export interface SyncErrorLike { code?: string; message?: string }

export function isRevisionConflict(error: SyncErrorLike | null | undefined): boolean {
  return error?.code === 'P0001' && /CONFLICT/i.test(error.message ?? '');
}

export function canAutoRebase(eventId?: string): boolean {
  return !eventId;
}
